// Module
var code = "<!--<div class=\"flex-noshrink block-container\" ng-class=\"vm.block.config.classes\">-->\r\n<form-block ng-if=\"!!vm.formTemplate\" flex form-block=\"vm.block\" template=\"vm.formTemplate\"\r\n            on-change=\"vm.change()\"></form-block>\r\n<!--<div ng-if=\"!vm.formTemplate\">no no</div>-->\r\n<!--</div>-->";
// Exports
module.exports = code;